export default "__VITE_ASSET__f1RDKRby__"